import route from './routes';

export const routesWithTitle = {
  ACCOUNT_SETTINGS: {
    path: route.ACCOUNT_SETTINGS,
    title: 'operabase.general.m_SIDEBAR_SETTINGS',
  },
  ACCOUNT_SUBSCRIPTIONS: {
    path: route.ACCOUNT_SUBSCRIPTIONS,
    title: '',
  },
  ARTICLES: {
    path: route.ARTICLES,
    title: 'operabase.general.m_SIDEBAR_ARTICLES',
  },
  ARTISTS: {
    path: route.ARTISTS,
    title: 'operabase.general.m_ARTISTS',
  },
  CASTING_TOOL: {
    path: route.CASTING_TOOL,
    title: 'operabase.general.FN_CASTINGTOOL',
  },
  COMPANIES: {
    path: route.COMPANIES,
    title: 'operabase.general.m_OPCOS',
  },
  COMPETITIONS: {
    path: route.COMPETITIONS,
    title: 'operabase.general.m_COMPETITIONS',
  },
  COMPOSERS: {
    path: route.COMPOSERS,
    title: 'operabase.general.m_COMPOSERS',
  },
  CONTACT_OB: {
    path: route.CONTACT_OB,
    title: 'operabase.general.m_CONTACTUS',
    forceReload: true,
  },
  COOKIE_POLICY: {
    path: route.COOKIE_POLICY,
    title: '',
  },
  FESTIVALS: {
    path: route.FESTIVALS,
    title: 'operabase.general.m_FESTIVALS',
  },
  HIGHLIGHTS: {
    path: route.HIGHLIGHTS,
    title: 'operabase.general.m_HIGHLIGHTS',
  },
  HOME: {
    path: route.HOME,
    title: 'operabase.general.m_HOME',
  },
  INTRO_AGENTS: {
    path: route.INTRO_AGENTS,
    title: 'operabase.general.m_PROAGENT',
  },
  INTRO_AOS: {
    path: route.INTRO_AOS,
    title: 'operabase.general.m_PROAO',
  },
  INTRO_ARCHIVES: {
    path: route.INTRO_ARCHIVES,
    title: '',
  },
  INTRO_ARTISTS: {
    path: route.INTRO_ARTISTS,
    title: 'operabase.general.m_PROARTIST',
  },
  INTRO_OB: {
    path: route.INTRO_OB,
    title: 'operabase.general.m_INTRODUCTION',
  },
  JOURNALISTS_AND_RESEARCH: {
    path: route.JOURNALISTS_AND_RESEARCH,
    title: '',
  },
  LIBRARY: {
    path: route.LIBRARY,
    title: '',
  },
  LOGIN: {
    path: route.LOGIN,
    title: 'operabase.general.m_LOGIN',
  },
  MANAGERS: {
    path: route.MANAGERS,
    title: 'operabase.general.m_MANAGERS',
  },
  MAPS: {
    path: route.MAPS,
    title: 'operabase.general.m_MAPS',
  },
  NEW_RARE: {
    path: route.NEW_RARE,
    title: 'operabase.general.m_SIDEBAR_NEW_AND_RARE',
  },
  ON_THESE_DAY: {
    path: route.ON_THESE_DAY,
    title: 'operabase.general.m_ONTHISDAY',
  },
  PRIVACY: {
    path: route.PRIVACY,
    title: '',
  },
  PRODUCTIONS: {
    path: route.PRODUCTIONS,
    title: 'operabase.general.m_PERF',
  },
  REGISTER: {
    path: route.REGISTER,
    title: '',
  },
  RENTALS: {
    path: route.RENTALS,
    title: 'operabase.general.m_RENTALS',
  },
  RESET_PASSWORD: {
    path: route.RESET_PASSWORD,
    title: 'operabase.general.m_LOGIN_FORGOT_PASSWORD_BREADCRUMB',
  },
  SEASONS: {
    path: route.SEASONS,
    title: 'operabase.general.m_SEASON',
  },
  STATISTICS: {
    path: route.STATISTICS,
    title: 'operabase.general.m_STATISTICS',
  },
  STATS_NUMBERS: {
    path: route.STATS_NUMBERS,
    title: '',
  },
  TERMS_AND_CONDITIOS: {
    path: route.TERMS_AND_CONDITIOS,
    title: '',
  },
  VENUES: {
    path: route.VENUES,
    title: 'operabase.general.m_VENUES',
  },
  WORK_WITH_OB: {
    path: route.WORK_WITH_OB,
    title: '',
  },
  WORKS: {
    path: route.WORKS,
    title: 'operabase.general.FN_MUSICAL_WORKS_SECTION_NAME',
  },
};

export default routesWithTitle;
